const MAX_RECENT_SEARCHES = 5;

export const initialRecentSearchesState = {
  recentSearches: [],
  recentSearchesEnabled: true,
  suggestionsEnabled: false,
};

export const createRecentSearchesSlice = (set) => ({
  ...initialRecentSearchesState,

  // Recent searches can be either:
  // - string: plain text search
  // - object: { type: 'vehicle', eans: string, vehicleInfo: {...} }

  addRecentSearch: (term) => {
    if (!term || term.trim().length < 2) return;
    const trimmed = term.trim();

    set((state) => {
      // Filter out matching string searches (not vehicle searches)
      const filtered = state.recentSearches.filter(
        (s) => typeof s === 'object' || s !== trimmed
      );
      return {
        recentSearches: [trimmed, ...filtered].slice(0, MAX_RECENT_SEARCHES),
      };
    });
  },

  addVehicleSearch: (eans, vehicleInfo) => {
    const searchEntry = {
      type: 'vehicle',
      eans: eans.join('||'),
      vehicleInfo,
    };

    set((state) => {
      // Filter out any existing vehicle search with same vehicle
      const filtered = state.recentSearches.filter((s) => {
        if (typeof s === 'string') return true;
        if (s.type !== 'vehicle') return true;
        const v = s.vehicleInfo;
        return !(
          v.vendor === vehicleInfo.vendor &&
          v.model === vehicleInfo.model &&
          v.year === vehicleInfo.year &&
          v.version === vehicleInfo.version &&
          v.fitment === vehicleInfo.fitment
        );
      });
      return {
        recentSearches: [searchEntry, ...filtered].slice(0, MAX_RECENT_SEARCHES),
      };
    });
  },

  removeRecentSearch: (search) => {
    set((state) => ({
      recentSearches: state.recentSearches.filter((s) => {
        // If both are strings, compare directly
        if (typeof s === 'string' && typeof search === 'string') {
          return s !== search;
        }
        // If both are objects, compare by eans
        if (typeof s === 'object' && typeof search === 'object') {
          return s.eans !== search.eans;
        }
        // Different types, keep it
        return true;
      }),
    }));
  },

  clearRecentSearches: () => set({ recentSearches: [] }),

  setRecentSearchesEnabled: (enabled) => set({ recentSearchesEnabled: enabled }),
  setSuggestionsEnabled: (enabled) => set({ suggestionsEnabled: enabled }),
});
